import { HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthService } from '../../../shared/services/auth/auth.service';
import { ClientStore } from '../../../shared/stores/client/client.store';

export const clientSetupGuard: CanActivateFn = async (): Promise<boolean | UrlTree> => {
  const authService = inject(AuthService);
  const clientStore = inject(ClientStore);
  const router = inject(Router);

  if (clientStore.client()) {
    return true;
  }

  try {
    await authService.setupClient();
  } catch (error) {
    console.error('[clientSetupGuard] setupClient failed', error);

    if (error instanceof HttpErrorResponse) {
      if (error.status === 404) {
        return router.parseUrl('/auth/not-found');
      }

      if (error.status === 400) {
        return router.parseUrl('/auth/not-invited');
      }
    }

    authService.logout();
    return router.parseUrl('/');
  }

  if (!clientStore.client()) {
    authService.logout();
    return router.parseUrl('/');
  }

  return true;
};
